import EmailService from './EmailService';

export default class NotificationService {
  constructor() {
    this.emailService = new EmailService();
  }

  buildOverdueTemplate({ item, assignee, dueDate }) {
    const subject = `Inventory overdue: ${item.name}`;
    const body = `Hello ${assignee || 'there'},\n\nThis is a reminder that the item "${item.name}" (${item.reference}) was due back on ${dueDate || 'N/A'}.\n\nPlease arrange a return or let us know if an extension is needed.\n\nSafeguardPro Team`;
    return { subject, body };
  }

  sendEmail({ to, subject, body, templateKey, entity }) {
    return this.emailService.sendRaw({
      to,
      subject,
      text: body,
      html: body ? `<p>${body.replace(/\n/g, '<br />')}</p>` : '',
      templateKey,
      entity
    });
  }
}
